'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.mapStateToProps = mapStateToProps;

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

var _getNearby = require('shared/utils/getNearby');

var _getNearby2 = _interopRequireDefault(_getNearby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBER_OF_ROWS = 5;

var getDistance = function getDistance(obj, _ref) {
  var distance = _ref.distance;

  if (obj.distance && obj.distance < distance) {
    return obj.distance;
  }

  return distance;
};

var getNearestRows = function getNearestRows(obj) {
  var userLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (userLocation.lat && userLocation.lng) {
    var arr = (0, _objAsArray2.default)(obj);
    var locations = arr.reduce(function (locationsArr, row) {
      return locationsArr.concat(row.locations.map(function (location) {
        return (0, _extends5.default)({}, location, {
          id: row.id
        });
      }));
    }, []);

    var objWithDistance = (0, _getNearby2.default)(userLocation, locations).reduce(function (locationObj, location) {
      var distance = getDistance(locationObj, location);

      return (0, _extends5.default)({}, locationObj, (0, _defineProperty3.default)({}, location.id, (0, _extends5.default)({
        distance: distance
      }, locationObj[location.id], {
        locations: (0, _extends5.default)({}, (locationObj[location.id] || {}).locations, (0, _defineProperty3.default)({}, location.locationTitle, location))
      })));
    }, {});

    var rowsWithDistance = (0, _objAsArray2.default)(objWithDistance);

    return rowsWithDistance.sort(function (a, b) {
      return a.distance - b.distance;
    }).slice(0, NUMBER_OF_ROWS).map(function (_ref2) {
      var id = _ref2.id,
          distance = _ref2.distance;
      return (0, _extends5.default)({
        id: id,
        distance: distance
      }, obj[id]);
    });
  }

  return (0, _objAsArray2.default)(obj).slice(0, NUMBER_OF_ROWS);
};

function mapStateToProps(_ref3) {
  var keepInMind = _ref3.content.text.keepInMind,
      _ref3$data = _ref3.data,
      advisors = _ref3$data.advisors,
      employers = _ref3$data.employers,
      educators = _ref3$data.educators,
      location = _ref3.user.location,
      loading = _ref3.ui.jobNextSteps.loading;

  var steps = [{
    title: keepInMind.education.title,
    text: keepInMind.education.text,
    linkText: keepInMind.education.linkText,
    href: keepInMind.education.href
  }, {
    title: keepInMind.employers.title,
    text: keepInMind.employers.text,
    linkText: keepInMind.employers.linkText,
    href: keepInMind.employers.href
  }, {
    title: keepInMind.advising.title,
    text: keepInMind.advising.text,
    linkText: keepInMind.advising.linkText,
    href: keepInMind.advising.href
  }];

  return {
    steps: steps,
    loading: loading
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobNextSteps/selectors.js
// module id = 1211
// module chunks = 0